import { Box, Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./historytab.scss";
import HistoryList from "./HistoryList";
import { getHistoryList } from "../../../services/websiteApi";
import { useDispatch } from "react-redux";
import { setAPILoader } from "../../../state/actions/globalAction";
import { userInfoFetch } from "../../../utlis/commonFunction";
import UserDetailsHeader from "../UserDetailsHeader";
import { pageLocale } from "../../../utlis/locale";

const HistoryTab = () => {
  const [value, setValue] = useState(0);
  const { success, failed, inprogress } = pageLocale("history");
  const navTab = [success, failed, inprogress];

  const tabHandler = (newValue) => {
    setValue(newValue);
  };
  const dispatch = useDispatch();
  dispatch(setAPILoader(false));
  const [data, setData] = useState();
  const ALLOWED_MODULE_IDS = new Set([1, 4]);
  const filterByModule = (list) =>
    (list || []).filter((item) => ALLOWED_MODULE_IDS.has(item.moduleId));

  useEffect(() => {
    dispatch(setAPILoader(true));
    getHistoryList(userInfoFetch()?.id)
      .then((res) => {
        const raw = res?.data?.data;
        setData({
          success: filterByModule(raw?.success),
          failed: filterByModule(raw?.failed),
          inprogress: filterByModule(raw?.inprogress),
        });
        dispatch(setAPILoader(false));
      })
      .catch(() => {
        dispatch(setAPILoader(false));
      });
  }, []);

  return (
    <UserDetailsHeader>
      <Box className="history-nav-tab-box-wrapper">
        <Box className="history-nav-tab-menu-box">
          <div className="history-nav-tab-item-wrap">
            {navTab.map((item, index) => {
              return (
                <Tab
                  label={item}
                  key={index}
                  variant="fullWidth"
                  onClick={() => tabHandler(index)}
                  className={`history-nav-tab-menu-item + ${value === index && `selected`}`}
                />
              );
            })}
          </div>
        </Box>
        {value === 0 && (
          <div value="1" className="history-info-block">
            <HistoryList data={data?.success} />
          </div>
        )}
        {value === 1 && (
          <div value="2" className="history-info-block">
            <HistoryList data={data?.failed} />
          </div>
        )}
        {value === 2 && (
          <div value="2" className="history-info-block">
            <HistoryList data={data?.inprogress} />
          </div>
        )}
      </Box>
    </UserDetailsHeader>
  );
};

export default HistoryTab;
